import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./Slider.css";
import { Pagination } from "swiper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Person1 from "../../Assets/images/PNG/Form_Ai/Committ_person1.png";
import Person2 from "../../Assets/images/PNG/Form_Ai/Committ_person2.png";
import Person3 from "../../Assets/images/PNG/Form_Ai/Committ_person3.png";
import Star2 from "../../Assets/images/PNG/Form_Ai/star1.png";
import Star1 from "../../Assets/images/PNG/Form_Ai/star2.png";

const Slider = () => {
  return (
    <Box className="slider" id="testominals">
      <Box className="slider_Section_Header">
        <Typography variant="h4" color="initial" fontWeight={600}>
          Certiform is loved by users
        </Typography>
      </Box>
      <Swiper
        slidesPerView={2}
        spaceBetween={30}
        pagination={{ clickable: true }}
        modules={[Pagination]}
        className="mySwiper"
      >
        <SwiperSlide className="swiperBox">
          <Box className="swiperImg">
            <div>
              <img src={Person1} alt="" />
            </div>
            <div className="SImg">
              <img src={Star1} alt="" />
            </div>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="h5" color="initial" fontWeight={600}>
              Savannah Nguyen
            </Typography>
            <Typography variant="body1" color="initial">
              Partner- Nogel Tube
            </Typography>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="body1" color="initial">
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do
              amet sint. Velit officia consequat duis enim velit mollit.
              Exercitation veniam consequat sunt nostrud amet.
            </Typography>
          </Box>
        </SwiperSlide>

        <SwiperSlide className="swiperBox">
          <Box className="swiperImg">
            <div>
              <img src={Person2} alt="" />
            </div>
            <div className="SImg">
              <img src={Star2} alt="" />
            </div>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="h5" color="initial" fontWeight={600}>
              Darlene Robertson
            </Typography>
            <Typography variant="body1" color="initial">
              Director M.C.U
            </Typography>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="body1" color="initial">
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do
              amet sint. Velit officia consequat duis enim velit mollit.
              Exercitation veniam consequat sunt nostrud amet.
            </Typography>
          </Box>
        </SwiperSlide>

        <SwiperSlide className="swiperBox">
          <Box className="swiperImg">
            <div>
              <img src={Person3} alt="" className="PImg" />
            </div>
            <div className="SImg">
              <img src={Star1} alt="" />
            </div>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="h5" color="initial" fontWeight={600}>
              Jacob Jones
            </Typography>
            <Typography variant="body1" color="initial">
              CEO JB Construction
            </Typography>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="body1" color="initial">
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do
              amet sint. Velit officia consequat duis enim velit mollit.
              Exercitation veniam consequat sunt nostrud amet.
            </Typography>
          </Box>
        </SwiperSlide>

        <SwiperSlide className="swiperBox">
          <Box className="swiperImg">
            <div>
              <img src={Person1} alt="" className="PImg" />
            </div>
            <div className="SImg">
              <img src={Star1} alt="" />
            </div>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="h5" color="initial" fontWeight={600}>
              Savannah Nguyen
            </Typography>
            <Typography variant="body1" color="initial">
              Partner- Nogel Tube
            </Typography>
          </Box>
          <Box className="swiper_heading">
            <Typography variant="body1" color="initial">
              Amet minim mollit non deserunt ullamco est sit aliqua dolor do
              amet sint. Velit officia consequat duis enim velit mollit.
              Exercitation veniam consequat sunt nostrud amet.
            </Typography>
          </Box>
        </SwiperSlide>
      </Swiper>
    </Box>
  );
};

export default Slider;
